module.exports = __webpack_public_path__ + "static/media/question5.3316c091.svg";